export const OVERVIEW_KEYS = {
  //Key Information
  DATE_OF_REGISTRATION: 'registerDate',
  COMPANY_TYPE: 'companyType',
  ACCOUNTING_PERIOD: 'accountingPeriod',
  LEGAL_FORM: 'legalFormName',
  LEGAL_REPRESENTATIVE: 'legalRepresentative',
  NUMBER_OF_EMPLOYEES: 'numberOfEmployee',
  //Contact
  WEBSITE: 'website',
  EMAIL: 'email',
  PHONE: 'telephone',
  FAX: 'fax',
  ADDRESS: 'address',
  // Map
  MAP: 'MAP',
}

export const BOX_DATA = [
  { title: 'companySummary.overview.KEY_INFORMATION', dataKeyCount: 6 },
  { title: 'companySummary.overview.CONTACT', dataKeyCount: 5 },
  { title: '', dataKeyCount: 1 },
]
